import { Moment } from "moment";
import { AppThunk, AppDispatch } from "../../types";
import fetchReport from "../../../shared/fetchReport";

type FetchStartedAdsByPublicationProps = {
  startDate: Moment;
  endDate: Moment;
  report: string;
};
export type FetchStartedAdsByPublication = (filters: FetchStartedAdsByPublicationProps) => void;

const fetchStartedAdsByPublication = ({
  startDate,
  endDate,
  report
}: FetchStartedAdsByPublicationProps): AppThunk => async (dispatch: AppDispatch) => {
  const params = {
    start_date: startDate.format("YYYY-MM-DD"),
    end_date: endDate.format("YYYY-MM-DD"),
  };
  await fetchReport(report, dispatch, params);
};

export default fetchStartedAdsByPublication;
